let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kNFvF"), load("ffQaD"), load("kvRbA"), load("fZ3Mx")]).then(() => parcelRequire('bgMER'));